export default __webpack_public_path__ + "static/media/const1.2617eb37.jpg";